/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GroupSetParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['minimumSize', codecNumber, 'minimum_size'],
    ['maximumSize', codecNumber, 'maximum_size'],
    ['assignmentIds', /* #__PURE__ */ codecArray(codecNumber), 'assignment_ids'],
]);
export class GroupSet extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GroupSetParser.decode(input).map(res => new GroupSet(res));
    }
    static unsafeDecode(input) {
        return GroupSet.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GroupSetParser.encode(data);
    }
    static schema() {
        return GroupSetParser.schema();
    }
}
